import { Link } from "react-router-dom"
import { Github, Mail, Heart } from "lucide-react"

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-gray-600 text-sm">© {new Date().getFullYear()} Mnemonic Hub. All rights reserved.</p>
          </div>

          <div className="flex space-x-6 mb-4 md:mb-0">
            <Link to="/about" className="text-gray-600 hover:text-gray-900 transition-colors">
              About
            </Link>
            <a
              href="https://github.com/Biki-dev"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-900 transition-colors flex items-center space-x-1"
            >
              
  <span>GitHub</span>

            </a>
            <a
              href="mailto:quotex99575@gmail.com"
              className="text-gray-600 hover:text-gray-900 transition-colors flex items-center space-x-1"
            >
              <Mail className="w-4 h-4" />
              <span>Contact</span>
            </a>
          </div>

          <div className="flex items-center text-gray-600 text-sm">
            <span className="flex items-center">
              Built with <Heart className="w-4 h-4 mx-1 text-red-500" /> by Biki Kalita
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
